import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface ReservationEventsResponse {
  reservation_uuid: string
  professional_uuid: string
  patient_uuid: string
  next_dates: string[]
}

export async function getNextReservationEvents(reservationUUID: string): Promise<ReservationEventsResponse> {
  const { data } = await axios.get<ReservationEventsResponse>(apiEndpoints.NEXT_RESERVATION_EVENTS(reservationUUID))

  return data
}